import React from 'react';
import { useLang } from '../context/LanguageContext';
import { Loader2, WifiOff } from 'lucide-react';

export function LoadingView() {
  const { t } = useLang();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 text-[#E5C158]" data-testid="loading-view">
      <Loader2 className="animate-spin" size={32} />
      <span className="font-mono text-xs tracking-widest uppercase text-slate-400">{t('loading')}</span>
    </div>
  );
}

export function ErrorView({ onRetry }) {
  const { t } = useLang();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-5 px-8 text-center" data-testid="error-view">
      <WifiOff size={36} className="text-[#D4AF37]/60" />
      <p className="font-sans text-slate-300">{t('connectionIssue')}</p>
      <button
        data-testid="retry-button"
        onClick={onRetry}
        className="bg-transparent border border-[#D4AF37] text-[#E5C158] hover:bg-[#D4AF37]/10 font-semibold py-3 px-8 rounded-xl transition-all"
      >
        {t('retry')}
      </button>
    </div>
  );
}
